import { biomarkerRangeInPercentage, getBiomarkerRangeColorOrder } from '../../utils/miscUtils';
import React from 'react';
import {
  IDiagnoseResult,
  IDigitalHealthProfile,
} from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';
import styles from './BiomarkerRangeSmall.module.css';
import BiomarkerRangeSvg from '../BioMarkerRange/BioMarkerSvg';

type Props = {
  product: IDigitalHealthProfile;
  biomarker: IDiagnoseResult;
};

const BiomarkerRangeSmall: React.FC<Props> = ({ product, biomarker }) => {
  const biomarkerPosition: Record<number, number> = {
    1: -9.5,
    2: 10,
    3: 30.5,
    5: 51,
    6: 70,
  };

  const ranges = React.useMemo(() => {
    return product.diagnose_reference_ranges?.filter(
      (range) => range.property_id === biomarker.property_id
    );
  }, [biomarker]);

  const value = React.useMemo(() => {
    const order = getBiomarkerRangeColorOrder(biomarker, product);
    return (
      biomarkerPosition[order] + (biomarkerRangeInPercentage(biomarker, product, order) * 19) / 100
    );
  }, [ranges]);

  return (
    <div className={styles.container}>
      <div
        className={styles.bar}
        style={{
          background:
            biomarker.property_value === 'test_aborted'
              ? 'none'
              : 'linear-gradient(to right, #FF0300 0%, #FF0300 19%, #FFA800 20.25%, #FFA800 39.25%, #FFFFFF 39.25%, #FFFFFF 40.5%, #46D278 40.5%, #46D278 59.5%, #FFFFFF 59.5%, #FFFFFF 60.75%, #FFA800 60.75%, #FFA800 79.75%, #FF0300 81%, #FF0300 100%)',
        }}
      />
      <div
        className={styles.referenceRanges}
        style={{
          left: `${
            biomarker.property_id < 0
              ? biomarker?.reference_range_name === 'Positive'
                ? 20
                : 20
              : value
          }%`,
        }}
      >
        <BiomarkerRangeSvg
          width={16}
          height={13}
          fill={`#4F4F4F`}
          className={styles.rangeSvg}
          style={{ left: '50%' }}
        />
      </div>
    </div>
  );
};

export default BiomarkerRangeSmall;
